import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";
import basketReducer from "./features/basket/basketSlice";
import authReducer from "./features/auth/authSlice";
import countryReducer from "./features/country/countrySlice";

export default configureStore({
  reducer: {
    basket: basketReducer,
    auth: authReducer,
    country: countryReducer,
  },
  middleware: getDefaultMiddleware({
    serializableCheck: false,
  }),
});
